import { AIContext } from 'contexts/AIContext';
import { CompanyContext } from 'contexts/CompanyContext';
import { useContext, useEffect, useState } from 'react'
import { aiListTextToArray } from 'utils/aiListTextToArray';

const useQuestionsContexts = () => {

  const { getByQueryChat } = useContext(AIContext);
  const { company } = useContext(CompanyContext);

  const getQuestionsContexts = async (query = ``, qty = 15, others = []) => {
    const _query = `
      Write ${qty} interesting questions for ${company?.name} ${query && ` about ${query}`}. 

      INSTRUCTIONS: 
      - Separate each question using a new line. 
      - Each question must have less than 15 words.
      - Do not answer in list format. 
      - Do not enumerate every option. 

      ${!!others?.length ? `Make them different from the following questions: ${others?.join('\n')}` : ``}

      Questions: 
    `;

    let questions = await getByQueryChat(_query, true).then((response) => response);
    
    return aiListTextToArray(questions);
  }

  return { getQuestionsContexts }
}

export default useQuestionsContexts;
